import { Box } from '../Box/Box'
import {
  CircularProgress as MuiCircularProgress,
  CircularProgressProps as MuiCircularProgressProps
} from '@mui/material'
import { Typography } from '../Typography/Typography'
import React from 'react'

export type CircularProgressProps = Pick<MuiCircularProgressProps, 'value'> & {
  showPercentage?: boolean
}
export const CircularProgress: React.FC<CircularProgressProps> = ({
  value,
  showPercentage = false
}) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', width: 'min-content' }}>
      <MuiCircularProgress variant={value ? 'determinate' : 'indeterminate'} value={value} />
      {showPercentage && (
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Typography variant="caption" component="div" color="text.secondary">{`${Math.round(
            value || 0
          )}%`}</Typography>
        </Box>
      )}
    </Box>
  )
}
